import BrokenRolls from "@/pages/rollshop/pages/broken_rolls";
import RollshopNotification from "@/pages/rollshop/pages/notifications";
import Operation from "@/pages/rollshop/pages/operations";
import Rollset from "@/pages/rollshop/pages/rollsets";
import Spare from "@/pages/rollshop/pages/spare";

export const routeRollsets = "rollshop/rollsets";
export const routeRollshopNotifications = "rollshop/notifications";
export const routeBrokenRolls = "rollshop/broken-rolls";
export const routeSpare = "/spare";
export const routeRollshopOperations = "/rollshop-operations";
const rollshopSparePermission = "ui.navbar.rollshop.spare";
export const rollshopNotificationsPermission =
	"ui.navbar.rollshop.notifications";
const rollshopOperationsPermission = "ui.navbar.rollshop.operations";
export const rollshopRollsetsPermission = "ui.navbar.rollshop.rollsets";

export const rollshopRoutes = [
	{
		path: routeSpare,
		element: <Spare />,
		permission: rollshopSparePermission,
	},
	{
		path: routeRollsets,
		element: <Rollset />,
		permission: rollshopRollsetsPermission,
	},
	{
		path: `${routeRollsets}/:sectionId`,
		element: <Rollset />,
		permission: rollshopRollsetsPermission,
	},
	{
		path: routeRollshopNotifications,
		element: <RollshopNotification />,
		permission: rollshopNotificationsPermission,
	},
	{
		path: `${routeRollshopNotifications}/:shiftId`,
		element: <RollshopNotification />,
		permission: rollshopNotificationsPermission,
	},
	{
		path: routeBrokenRolls,
		element: <BrokenRolls />,
	},

	{
		path: routeRollshopOperations,
		element: <Operation />,
		permission: rollshopOperationsPermission,
	},
	{
		path: `${routeRollshopOperations}/:partId`,
		element: <Operation />,
		permission: rollshopOperationsPermission,
	},
];
